import React, { FC } from 'react'
import styles from './artistProfile.module.scss'
import SALink from 'components/SALink'
const TITLE = 'Browse Other Artworks'
const OWN_ACCOUNT_TITLE = 'Upload Artworks'
import { useSelector } from 'react-redux'
import { getIsUsersArtworksAccount } from '../selectors'
import useQA from 'hooks/useQA'
const NoResults: FC = () => {
  const isMyOwnAccount = useSelector(getIsUsersArtworksAccount)
  const { testId } = useQA()
  return (
    <div className={styles.noResults}>
      <div className={styles.noResultsGrid} {...testId('no-results')}>
        {isMyOwnAccount ? (
          <>
            <p className={styles.text}>You have no artworks</p>
            <SALink href={`/studio/upload`} title={OWN_ACCOUNT_TITLE}>
              <div className={styles.ctaButton}>
                <p className={styles.buttonText}>{OWN_ACCOUNT_TITLE}</p>
              </div>
            </SALink>
          </>
        ) : (
          <>
            <p className={styles.text}>
              This is a new artist shop in the making. Check back for updates.
            </p>
            <SALink href={`/all`} title={TITLE}>
              <div className={styles.ctaButton}>
                <p className={styles.buttonText}>{TITLE}</p>
              </div>
            </SALink>
          </>
        )}
      </div>
    </div>
  )
}

export default NoResults
